import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'

import { getIntegrationRequests } from 'legacy/services/carrier'

import { ThirdPartyRequest } from './ThirdPartyRequest'

export function ThirdPartyRequestsList() {
  const [integrationRequests, setIntegrationRequests] = useState(null)

  async function fetchIntegrationRequests() {
    try {
      const res = await getIntegrationRequests('pending')
      if (res.status === 200 && res.data.count > 0) setIntegrationRequests([res.data.data])
    } catch {
      toast.error('Cannot get pending Integration Requests')
    }
  }

  useEffect(() => {
    fetchIntegrationRequests()
  }, [])

  if (!integrationRequests) {
    return null
  }

  return integrationRequests.map(({ partner_name: partnerName, id }) => (
    <ThirdPartyRequest key={`integration-request-${id}`} id={id} partnerName={partnerName} />
  ))
}
